import PropTypes from 'prop-types';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';

const LoadingSpinner = ({ 
  message = "Loading...", 
  size = "large", 
  color = "white",
  showMessage = true,
  style = {}
}) => {
  return (
    <View style={[styles.container, style]}>
      <ActivityIndicator size={size} color={color} />
      {showMessage && (
        <Text style={[styles.message, { color }]}>{message}</Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  message: {
    marginTop: 16,
    fontSize: 16,
    textAlign: 'center',
    fontWeight: '500',
  },
});

LoadingSpinner.propTypes = {
  message: PropTypes.string,
  size: PropTypes.oneOf(['small', 'large']),
  color: PropTypes.string,
  showMessage: PropTypes.bool,
  style: PropTypes.object,
};

export default LoadingSpinner;